module.exports = __webpack_public_path__ + "img/24.5d9a5c17.jpg";